"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Body = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _utils = require("@navinc/utils");

var _baseReactComponents = require("@navinc/base-react-components");

var _isOfferPrequal = _interopRequireDefault(require("../is-offer-prequal"));

var _matchFactor = _interopRequireDefault(require("../../match-factor"));

var _index = _interopRequireDefault(require("../../match-factor-score/index.js"));

var _details = _interopRequireDefault(require("./details"));

var _hiddenForm = _interopRequireDefault(require("./hidden-form"));

var _yotpo = _interopRequireDefault(require("../../common/yotpo"));

var _styles = require("./styles");

var _offerStyles = require("../../common/offer-styles");

var _offerLinkAttributes = require("../../util/offer-link-attributes");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Body = function Body(_ref) {
  var _ref$creditCardOffer = _ref.creditCardOffer,
      creditCardOffer = _ref$creditCardOffer === void 0 ? {} : _ref$creditCardOffer,
      detailLink = _ref.detailLink,
      yotpo = _ref.yotpo,
      _ref$isPersonal = _ref.isPersonal,
      isPersonal = _ref$isPersonal === void 0 ? false : _ref$isPersonal,
      client = _ref.client,
      enterpriseUuid = _ref.enterpriseUuid,
      order = _ref.order,
      onApplyNow = _ref.onApplyNow,
      locationUrl = _ref.locationUrl,
      shouldUseMfScore = _ref.shouldUseMfScore,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? '' : _ref$highlight,
      category = _ref.category,
      referralName = _ref.referralName,
      referralTarget = _ref.referralTarget,
      referralType = _ref.referralType;

  var _useLaunchDarkly = (0, _baseReactComponents.useLaunchDarkly)(),
      hasLDProvider = _useLaunchDarkly.hasProvider,
      trackOfferReferral = _useLaunchDarkly.trackOfferReferral;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      shouldShowDetails = _useState2[0],
      setShouldShowDetails = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isPrequalApplyDisabled = _useState4[0],
      setIsPrequalApplyDisabled = _useState4[1];

  var scrollWaypoint = (0, _react.useRef)(null);
  var isPrequalified = (0, _isOfferPrequal["default"])(creditCardOffer);
  var isAmex = (0, _lodash["default"])(creditCardOffer, 'issuer', '') === 'American Express';
  var partnerText = (0, _lodash["default"])(creditCardOffer, 'terms.partnerText', '');
  var termsLinkText = (0, _lodash["default"])(creditCardOffer, 'terms.linkText', '');
  var termsLink = (0, _lodash["default"])(creditCardOffer, 'terms.link', '');
  var matchFactorScore = (0, _lodash["default"])(creditCardOffer, 'matchFactor');

  var toggleDetails = function toggleDetails() {
    setShouldShowDetails(!shouldShowDetails);
  };

  var scrollAndToggle = function scrollAndToggle() {
    toggleDetails();

    if (shouldShowDetails) {
      scrollWaypoint.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  var _trackApply = function trackApply() {
    (0, _utils.tealiumTrack)({
      tealium_event: 'referral',
      action: 'referral',
      category: category,
      label: locationUrl,
      matchFactorScore: matchFactorScore,
      accountId: enterpriseUuid,
      mfSource: creditCardOffer.mfSource,
      offerCategory: "credit-cards ".concat(creditCardOffer.category),
      offerId: creditCardOffer.id,
      offerName: creditCardOffer.name,
      offerSubCategory: '',
      offerBrand: creditCardOffer.issuer,
      order: order,
      referralName: referralName,
      referralTarget: referralTarget,
      referralType: referralType,
      rtid: creditCardOffer.rtid,
      rsid: creditCardOffer.rsid,
      offerLink: creditCardOffer.applyUrl,
      partnerId: '',
      client: client,
      value: 0
    });
  };

  var disablePrequalApply = function disablePrequalApply() {
    return (0, _isOfferPrequal["default"])(creditCardOffer) && setIsPrequalApplyDisabled(true);
  };

  var trackDetails = function trackDetails() {
    return (0, _utils.tealiumTrack)({
      tealium_event: 'ccSeeDetails',
      action: 'ccSeeDetails',
      label: locationUrl,
      matchFactorScore: matchFactorScore,
      accountId: enterpriseUuid,
      offerCategory: creditCardOffer.category,
      offerId: creditCardOffer.id,
      offerName: creditCardOffer.name,
      offerBrand: creditCardOffer.issuer,
      order: order,
      client: client
    });
  };

  var handleDetailsClick = function handleDetailsClick() {
    trackDetails();
    toggleDetails();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ScrollWayPoint, {
      ref: scrollWaypoint
    }), highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.Highlight, {
      size: "xxs",
      bold: true,
      "data-testid": "creditcardcard:highlight",
      children: highlight
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FirstLook, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.WrapDiv, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CcTitle, {
          size: "md",
          bold: true,
          "data-testid": "creditcardcard:credit-card-title",
          children: (0, _lodash["default"])(creditCardOffer, 'name', '')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.TermsContainer, {
          children: [partnerText, termsLink && /*#__PURE__*/(0, _jsxRuntime.jsx)(_offerStyles.CcTermsLink, {
            href: termsLink,
            target: "_blank",
            children: termsLinkText
          }), isAmex && 'Terms Apply']
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Summary, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Aprs, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Apr, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AprTitle, {
                size: "xs",
                shouldScaleFont: true,
                light: true,
                children: [(0, _lodash["default"])(creditCardOffer, 'aprs.purchaseApr.title', ''), ' ']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "xs",
                shouldScaleFont: true,
                light: true,
                bold: true,
                children: (0, _lodash["default"])(creditCardOffer, 'aprs.purchaseApr.description', '')
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Apr, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AprTitle, {
                size: "xs",
                shouldScaleFont: true,
                light: true,
                children: [(0, _lodash["default"])(creditCardOffer, 'fees.annualFee.title', ''), ' ']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "xs",
                shouldScaleFont: true,
                light: true,
                bold: true,
                children: (0, _lodash["default"])(creditCardOffer, 'fees.annualFee.description', '')
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileImgDiv, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Img, {
              src: (0, _lodash["default"])(creditCardOffer, 'image.high', ''),
              alt: creditCardOffer.name
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopImgDiv, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Img, {
          src: (0, _lodash["default"])(creditCardOffer, 'image.high', ''),
          alt: creditCardOffer.name
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ButtonBottomDiv, {
      children: [isPrequalified && /*#__PURE__*/(0, _jsxRuntime.jsx)(_hiddenForm["default"], {
        applyUrl: (0, _lodash["default"])(creditCardOffer, 'applyUrl.applyUrl'),
        acquisitionOfferId: (0, _lodash["default"])(creditCardOffer, 'applyUrl.acquisitionOfferId'),
        acquisitionWebToken: (0, _lodash["default"])(creditCardOffer, 'applyUrl.acquisitionWebToken'),
        applicantRequestToken: (0, _lodash["default"])(creditCardOffer, 'applyUrl.applicantRequestToken'),
        formId: (0, _lodash["default"])(creditCardOffer, 'id'),
        disableApply: disablePrequalApply
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ApplyButton, Object.assign({
        rel: "noopener noreferrer",
        target: "_blank",
        size: "large",
        "data-testid": "creditcardcard:apply-button"
      }, (0, _offerLinkAttributes.offerLinkAttributes)(!isPrequalified ? (0, _lodash["default"])(creditCardOffer, 'applyUrl', '') : undefined), {
        onClick: function onClick() {
          _trackApply();

          !!hasLDProvider && trackOfferReferral(creditCardOffer);
          if (onApplyNow) onApplyNow(creditCardOffer);
        },
        disabled: isPrequalApplyDisabled,
        form: isPrequalified ? "hidden_form_".concat((0, _lodash["default"])(creditCardOffer, 'id')) : undefined,
        children: "Apply now"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CardBottom, {
        children: [yotpo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_yotpo["default"], Object.assign({
          "data-testid": "creditcardcard:yotpo"
        }, yotpo)) : shouldUseMfScore ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index["default"], {
          score: matchFactorScore,
          isPrequalified: isPrequalified,
          onClick: handleDetailsClick
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_matchFactor["default"], {
          score: matchFactorScore,
          isPrequalified: isPrequalified,
          onClick: handleDetailsClick
        }), detailLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "xs",
          shouldScaleFont: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoggedOutLink, {
            target: "_self",
            href: detailLink,
            "data-testid": "creditcardcard:detaillink",
            children: "See details"
          })
        }) : detailLink == null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailsLink, {
          onClick: handleDetailsClick,
          shouldShowDetails: shouldShowDetails,
          "data-testid": "creditcardcard:toggledetails",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SeeDetails, {
            children: shouldShowDetails ? 'Hide details' : 'See details'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Chevron, {
            shouldShowDetails: shouldShowDetails,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
              name: "actions/carrot-up",
              color: _baseReactComponents.theme.neutral400
            })
          })]
        }) : null]
      })]
    }), shouldShowDetails && /*#__PURE__*/(0, _jsxRuntime.jsx)(_details["default"], {
      creditCardOffer: creditCardOffer,
      shouldShowDetails: shouldShowDetails,
      scrollAndToggle: scrollAndToggle,
      isPersonal: isPersonal,
      trackApply: function trackApply(args) {
        !!hasLDProvider && trackOfferReferral(creditCardOffer);

        _trackApply(args);
      },
      order: order,
      trackDetails: trackDetails,
      isPrequalApplyDisabled: isPrequalApplyDisabled,
      onApplyNow: onApplyNow
    })]
  });
};

exports.Body = Body;

var _default = (0, _styledComponents["default"])(Body).withConfig({
  componentId: "sc-13ecvhg-0"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=body.js.map